import Cookies from 'js-cookie';

export type Destination = 'internal' | 'marketing';
type Integrations = Record<string, unknown>;

const cookieName = 'amplitude-session-id';

const getSessionId = (): number => {
  const sessionId = Number(Cookies.get(cookieName));
  return Number.isNaN(sessionId) ? Date.now() : sessionId;
};

/**
 * Note: Prior to March 2024, the 'internal' destination only sent events to certain
 * Segment destinations. Going forward, setting either internal or marketing will send events
 * everywhere, and filtering will be done in the Segment UI.
 *
 * We are keeping the two options here to allow for a smoother transition.
 */
export const segmentIntegrations: Record<Destination, Integrations> = {
  internal: {
    All: true,
    Amplitude: { session_id: getSessionId() },
  },
  marketing: { All: true },
};

// these are used when the user has opted out of tracking (or there is no user)
export const privacyOptOutIntegrations: Integrations = {
  All: false,
};

const getOptions = ({
  destination,
}: {
  destination?: Destination | undefined;
}): Integrations => ({
  integrations: segmentIntegrations[destination || 'internal'],
});

export default getOptions;
